import { IPromise, IQService } from "angular";

export const batchGenerator = function* <T>(arr: Array<T>, batchSize: number): Generator {
  if (arr.length <= batchSize) {
    yield [...arr];
  } else {
    let total = 0;
    for (let i = 0; i < arr.length; i += batchSize) {
      total += batchSize;
      yield arr.slice(i, i + batchSize);
    }

    if (total < arr.length) {
      yield arr.slice(total, arr.length);
    }
  }
};

export function handleRequestsInBatches<T, R>(collection: Array<T>, promiseMappingFn: (item: T) => IPromise<R>, batchSize: number, $q: IQService): IPromise<void> {
  const collectionBatches = batchGenerator(collection, batchSize);

  const process = (nextBatch): IPromise<void> => {
    if (nextBatch.done) {
      return $q.resolve();
    }

    const collectionBatch = nextBatch.value;

    if (Array.isArray(collectionBatch)) {
      const batchPromises = collectionBatch.map((item) => promiseMappingFn(item));

      return $q
        .all(batchPromises)
        .then(() => {
          const nextBatch = collectionBatches.next();
          return process(nextBatch);
        })
        .catch(() => $q.reject());
    }
  };

  const firstBatch = collectionBatches.next();
  return process(firstBatch);
}
